import BaseLineItemEntity from '../baseclasses/BaseLineItemEntity'
import SuppressionReason from '../entities/SuppressionReason'
import Customer from '../entities/Customer'
export class PaperworkOnlyMoveLineItem extends BaseLineItemEntity {
    ID?: number;
    FromCustomerNumber?: string;
    FromCustomer?: Customer;
    ToCustomerNumber?: string;
    ToCustomer?: Customer;
    SerialNumber?: string;
    Description?: string;
    SuppressCustomer?: boolean;
    SuppressionReasonID?: number;
    SuppressionReason?: SuppressionReason;
    LostFound?: boolean;
}

export default PaperworkOnlyMoveLineItem;
